// assets
import { PersonSearch, Groups3, People } from '@mui/icons-material';

// constant
const icons = {
    PersonSearch,
    Groups3,
    People
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const search = {
    id: 'search',
    title: 'Search',
    type: 'group',
    children: [
        {
            id: 'accountSearch',
            title: 'Account',
            type: 'item',
            url: '/search/account',
            icon: icons.PersonSearch
        },
        {
            id: 'teamSearch',
            title: 'Team',
            type: 'item',
            url: '/search/team',
            icon: icons.Groups3
        },
        {
            id: 'memberSearch',
            title: 'Member',
            type: 'item',
            url: '/search/member',
            icon: icons.People
        }
    ]
};

export default search;
